import { connect } from 'react-redux';
import { showExitPopup } from '../../../actions';
import FooterItem from './FooterItem';

export default connect(null, { showExitPopup })(FooterItem);
